import { 
  LayoutDashboard, 
  Users, 
  Receipt, 
  BarChart3, 
  Settings, 
  CreditCard, 
  TrendingUp, 
  Shield, 
  Bell, 
  FileText, 
  Banknote, 
  Building, 
  UserCheck, 
  Activity, 
  Crown, 
  Headphones, 
  MessageCircle, 
  Building2, 
  Store, 
  TestTube, 
  Gift, 
  Database, 
  QrCode,
  DollarSign,
  ShieldCheck,
  Zap,
  Percent,
  AlertTriangle,
  PieChart,
  Filter,
  LucideIcon
} from "lucide-react";

export interface AdminRouteConfig {
  path: string;
  label: string;
  icon: LucideIcon;
  desc: string;
  group: string;
  protected: boolean;
  layout: boolean;
  redirect?: string; // If set, this route redirects to another
}

export interface AdminMenuGroup {
  title: string;
  items: AdminRouteConfig[];
}

// ============================================
// CENTRALIZED ADMIN ROUTES CONFIG
// ซิงค์เมนู Sidebar, MenuGrid, และ Router ทั้งหมด
// ============================================

export const ADMIN_ROUTES: AdminRouteConfig[] = [
  // ============================================
  // Dashboard & Overview Group
  // ============================================
  {
    path: "/admin/dashboard",
    label: "แดชบอร์ดหลัก",
    icon: LayoutDashboard,
    desc: "ภาพรวมระบบและสถิติหลัก",
    group: "ภาพรวม",
    protected: true,
    layout: false // DirectAdminDashboard has its own layout
  },
  {
    path: "/admin/system-monitoring",
    label: "ติดตามระบบ",
    icon: Activity,
    desc: "ติดตาม CPU, Memory, Latency",
    group: "ภาพรวม",
    protected: true,
    layout: true
  },
  {
    path: "/admin/alert-analytics",
    label: "วิเคราะห์การแจ้งเตือน",
    icon: Bell,
    desc: "ติดตามกิจกรรมและแจ้งเตือน",
    group: "ภาพรวม",
    protected: true,
    layout: true
  },
  {
    path: "/admin/risk-report",
    label: "รายงานความเสี่ยง",
    icon: AlertTriangle,
    desc: "วิเคราะห์และประเมินความเสี่ยง",
    group: "ภาพรวม",
    protected: true,
    layout: true
  },
  {
    path: "/admin/fraud-detection",
    label: "ตรวจจับการฉ้อโกง",
    icon: Shield,
    desc: "ตรวจจับและจัดการธุรกรรมที่น่าสงสัย",
    group: "ภาพรวม",
    protected: true,
    layout: true
  },
  {
    path: "/admin/security-center",
    label: "ศูนย์ความปลอดภัย",
    icon: Shield,
    desc: "จัดการความปลอดภัยระบบ",
    group: "ภาพรวม",
    protected: true,
    layout: true
  },

  // ============================================
  // User Management Group
  // ============================================
  {
    path: "/admin/users-management",
    label: "จัดการผู้ใช้",
    icon: Users,
    desc: "ข้อมูลและการจัดการผู้ใช้",
    group: "จัดการผู้ใช้",
    protected: true,
    layout: true
  },
  {
    path: "/admin/users-credit",
    label: "เครดิตผู้ใช้",
    icon: DollarSign,
    desc: "ยอดเงินผู้ใช้ทั้งหมด",
    group: "จัดการผู้ใช้",
    protected: true,
    layout: true
  },
  {
    path: "/admin/admin-management",
    label: "จัดการแอดมิน",
    icon: UserCheck,
    desc: "จัดการผู้ใช้แอดมินและสิทธิ์",
    group: "จัดการผู้ใช้",
    protected: true,
    layout: true
  },

  // ============================================
  // Financial Management Group
  // ============================================
  {
    path: "/admin/transaction-management",
    label: "จัดการธุรกรรม",
    icon: Activity,
    desc: "รายการธุรกรรมในระบบ",
    group: "การเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/deposits",
    label: "ฝากเงิน",
    icon: TrendingUp,
    desc: "อนุมัติการฝากเงิน",
    group: "การเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/withdraws",
    label: "ถอนเงิน",
    icon: Banknote,
    desc: "อนุมัติการถอนเงิน",
    group: "การเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/reconciliation",
    label: "ตรวจสอบยอด",
    icon: ShieldCheck,
    desc: "ตรวจสอบความถูกต้องของยอดเงิน",
    group: "การเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/fee-management",
    label: "ค่าธรรมเนียม",
    icon: Receipt,
    desc: "จัดการค่าธรรมเนียมระบบ",
    group: "การเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/transaction-limits",
    label: "จำกัดธุรกรรม",
    icon: Shield,
    desc: "กำหนดวงเงินธุรกรรม",
    group: "การเงิน",
    protected: true,
    layout: true
  },

  // ============================================
  // Interest & Deposits Group
  // ============================================
  {
    path: "/admin/interest-settings",
    label: "ตั้งค่าดอกเบี้ย",
    icon: Percent,
    desc: "จัดการอัตราดอกเบี้ยและระบบจ่ายอัตโนมัติ",
    group: "ดอกเบี้ย",
    protected: true,
    layout: true
  },
  {
    path: "/admin/interest-payments",
    label: "จ่ายดอกเบี้ย",
    icon: TrendingUp,
    desc: "ดูประวัติการจ่ายดอกเบี้ย",
    group: "ดอกเบี้ย",
    protected: true,
    layout: true
  },
  {
    path: "/admin/fixed-deposits",
    label: "ฝากประจำ",
    icon: Building,
    desc: "ดูและจัดการบัญชีฝากประจำ",
    group: "ดอกเบี้ย",
    protected: true,
    layout: true
  },

  // ============================================
  // Banks & Currency Group
  // ============================================
  {
    path: "/admin/banks",
    label: "ธนาคาร",
    icon: CreditCard,
    desc: "เพิ่ม/แก้ไขธนาคารและโลโก้",
    group: "ธนาคาร & สกุลเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/system-banks",
    label: "ธนาคารระบบ",
    icon: CreditCard,
    desc: "จัดการธนาคารของระบบ",
    group: "ธนาคาร & สกุลเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/currencies",
    label: "สกุลเงิน",
    icon: Banknote,
    desc: "จัดการสกุลเงินและโลโก้",
    group: "ธนาคาร & สกุลเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/exchange-rates",
    label: "อัตราแลกเปลี่ยน",
    icon: TrendingUp,
    desc: "ตั้งค่าอัตราแลกเปลี่ยนและ spread",
    group: "ธนาคาร & สกุลเงิน",
    protected: true,
    layout: true
  },
  {
    path: "/admin/auto-exchange-rates",
    label: "อัตราอัตโนมัติ",
    icon: Zap,
    desc: "ดึงอัตราจาก API + Auto Update",
    group: "ธนาคาร & สกุลเงิน",
    protected: true,
    layout: true
  },

  // ============================================
  // Payment Gateway Group
  // ============================================
  {
    path: "/admin/payment-gateway-dashboard",
    label: "Payment Dashboard",
    icon: LayoutDashboard,
    desc: "ภาพรวม Payment Gateway",
    group: "Payment Gateway",
    protected: true,
    layout: true
  },
  {
    path: "/admin/payment-gateways",
    label: "Gateways",
    icon: CreditCard,
    desc: "จัดการ Payment Gateways",
    group: "Payment Gateway",
    protected: true,
    layout: true
  },
  {
    path: "/admin/payment-sessions",
    label: "Payment Sessions",
    icon: QrCode,
    desc: "ดู Payment Sessions",
    group: "Payment Gateway",
    protected: true,
    layout: true
  },
  {
    path: "/admin/merchant-payment-reports",
    label: "รายงาน",
    icon: BarChart3,
    desc: "รายงาน Merchant Payment",
    group: "Payment Gateway",
    protected: true,
    layout: true
  },
  {
    path: "/admin/webhook-logs",
    label: "Webhook Logs",
    icon: Activity,
    desc: "ดู Webhook Logs",
    group: "Payment Gateway",
    protected: true,
    layout: true
  },
  {
    path: "/admin/merchants",
    label: "ร้านค้า",
    icon: Store,
    desc: "จัดการร้านค้า",
    group: "Payment Gateway",
    protected: true,
    layout: true
  },
  {
    path: "/admin/test-merchant",
    label: "ทดสอบ",
    icon: TestTube,
    desc: "ทดสอบ Merchant",
    group: "Payment Gateway",
    protected: true,
    layout: true
  },
  {
    path: "/admin/payment-gateway-settings",
    label: "ตั้งค่า Gateway",
    icon: Settings,
    desc: "ตั้งค่า Payment Gateway",
    group: "Payment Gateway",
    protected: true,
    layout: true
  },

  // ============================================
  // Promotions & Events Group
  // ============================================
  {
    path: "/admin/promotions",
    label: "โปรโมชั่น",
    icon: Gift,
    desc: "สร้างและจัดการโปรโมชั่น",
    group: "โปรโมชั่น",
    protected: true,
    layout: true
  },
  {
    path: "/admin/lucky-wheel",
    label: "วงล้อนำโชค",
    icon: TrendingUp,
    desc: "ตั้งค่าเกมวงล้อโชคดี",
    group: "โปรโมชั่น",
    protected: true,
    layout: true
  },
  {
    path: "/admin/banners",
    label: "แบนเนอร์",
    icon: FileText,
    desc: "จัดการแบนเนอร์",
    group: "โปรโมชั่น",
    protected: true,
    layout: true
  },
  {
    path: "/admin/vip-levels",
    label: "ระดับ VIP",
    icon: Crown,
    desc: "ตั้งค่าระดับ VIP และสิทธิประโยชน์",
    group: "โปรโมชั่น",
    protected: true,
    layout: true
  },
  {
    path: "/admin/referral-system",
    label: "แนะนำเพื่อน",
    icon: Users,
    desc: "จัดการระบบแนะนำเพื่อน",
    group: "โปรโมชั่น",
    protected: true,
    layout: true
  },

  // ============================================
  // Reports & System Group
  // ============================================
  {
    path: "/admin/reports",
    label: "รายงาน",
    icon: PieChart,
    desc: "รายงานการใช้งานระบบ",
    group: "รายงานและระบบ",
    protected: true,
    layout: true
  },
  {
    path: "/admin/advanced-reporting",
    label: "รายงานขั้นสูง",
    icon: BarChart3,
    desc: "รายงานวิเคราะห์เชิงลึก",
    group: "รายงานและระบบ",
    protected: true,
    layout: true
  },
  {
    path: "/admin/notifications",
    label: "การแจ้งเตือน",
    icon: Bell,
    desc: "จัดการการแจ้งเตือน",
    group: "รายงานและระบบ",
    protected: true,
    layout: true
  },
  {
    path: "/admin/backup-management",
    label: "Backup",
    icon: Database,
    desc: "จัดการ Backup ระบบ",
    group: "รายงานและระบบ",
    protected: true,
    layout: true
  },
  {
    path: "/admin/logs",
    label: "ล็อกระบบ",
    icon: FileText,
    desc: "ประวัติการใช้งานระบบ",
    group: "รายงานและระบบ",
    protected: true,
    layout: true
  },
  {
    path: "/admin/receipts",
    label: "ใบเสร็จ",
    icon: Receipt,
    desc: "ดูและจัดการใบเสร็จ",
    group: "รายงานและระบบ",
    protected: true,
    layout: true
  },

  // ============================================
  // Support & Settings Group
  // ============================================
  {
    path: "/admin/support",
    label: "ฝ่ายสนับสนุน",
    icon: Headphones,
    desc: "แชทและการช่วยเหลือลูกค้า",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/whatsapp",
    label: "WhatsApp",
    icon: MessageCircle,
    desc: "จัดการ WhatsApp",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/company-settings",
    label: "ข้อมูลบริษัท",
    icon: Building2,
    desc: "จัดการโลโก้และข้อมูลบริษัท",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/custom-messages",
    label: "ข้อความระบบ",
    icon: MessageCircle,
    desc: "ปรับแต่งข้อความแสดงให้ลูกค้า",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/auth-performance",
    label: "สถิติ Login",
    icon: Activity,
    desc: "ประสิทธิภาพการเข้าสู่ระบบ",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/card-management",
    label: "จัดการบัตร",
    icon: CreditCard,
    desc: "จัดการบัตรเครดิต/เดบิต",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/account-inventory",
    label: "คลังบัญชี",
    icon: Receipt,
    desc: "จัดการเลขบัญชี",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/panel",
    label: "Admin Panel",
    icon: Settings,
    desc: "แผงควบคุมแอดมิน",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/settings",
    label: "ตั้งค่า",
    icon: Settings,
    desc: "จัดการการตั้งค่าทั่วไป",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  {
    path: "/admin/landing-page-settings",
    label: "ตั้งค่า Landing Page",
    icon: FileText,
    desc: "จัดการหน้าแรก",
    group: "การตั้งค่า",
    protected: true,
    layout: true
  },
  // ============================================
  // KYC Review
  // ============================================
  {
    path: "/admin/kyc-review",
    label: "ตรวจสอบ KYC",
    icon: UserCheck,
    desc: "อนุมัติและตรวจสอบ KYC",
    group: "จัดการผู้ใช้",
    protected: true,
    layout: true
  },
];

// ============================================
// REDIRECT ROUTES - เมนูซ้ำที่ต้อง redirect
// ============================================
export const ADMIN_REDIRECTS: { from: string; to: string }[] = [
  { from: "/admin/users", to: "/admin/users-management" },
  { from: "/admin/transactions", to: "/admin/transaction-management" },
  { from: "/admin/fee-settings", to: "/admin/fee-management" },
  { from: "/admin/dashboard-fixed", to: "/admin/dashboard" },
  { from: "/admin/full-dashboard", to: "/admin/dashboard" },
  { from: "/admin/logs-realtime", to: "/admin/logs" },
  { from: "/admin/logs-filter", to: "/admin/logs" },
  { from: "/admin/alerts-analytics", to: "/admin/alert-analytics" },
];

// ============================================
// HELPER FUNCTIONS
// ============================================

// Path → translation key mapping
const PATH_TO_LABEL_KEY: Record<string, string> = {
  "/admin/dashboard": "adminRoutes.labels.mainDashboard",
  "/admin/system-monitoring": "adminRoutes.labels.systemMonitoring",
  "/admin/alert-analytics": "adminRoutes.labels.alertAnalytics",
  "/admin/risk-report": "adminRoutes.labels.riskReport",
  "/admin/fraud-detection": "adminRoutes.labels.fraudDetection",
  "/admin/security-center": "adminRoutes.labels.securityCenter",
  "/admin/users-management": "adminRoutes.labels.manageUsers",
  "/admin/users-credit": "adminRoutes.labels.userCredits",
  "/admin/admin-management": "adminRoutes.labels.manageAdmins",
  "/admin/transaction-management": "adminRoutes.labels.manageTransactions",
  "/admin/deposits": "adminRoutes.labels.deposit",
  "/admin/withdraws": "adminRoutes.labels.withdraw",
  "/admin/reconciliation": "adminRoutes.labels.reconciliation",
  "/admin/fee-management": "adminRoutes.labels.fees",
  "/admin/transaction-limits": "adminRoutes.labels.transactionLimits",
  "/admin/interest-settings": "adminRoutes.labels.interestSettings",
  "/admin/interest-payments": "adminRoutes.labels.interestPayments",
  "/admin/fixed-deposits": "adminRoutes.labels.fixedDeposits",
  "/admin/banks": "adminRoutes.labels.banks",
  "/admin/system-banks": "adminRoutes.labels.systemBanks",
  "/admin/currencies": "adminRoutes.labels.currencies",
  "/admin/exchange-rates": "adminRoutes.labels.exchangeRates",
  "/admin/auto-exchange-rates": "adminRoutes.labels.autoExchangeRates",
  "/admin/payment-gateway-dashboard": "adminRoutes.labels.paymentDashboard",
  "/admin/payment-gateways": "adminRoutes.labels.gateways",
  "/admin/payment-sessions": "adminRoutes.labels.paymentSessions",
  "/admin/merchant-payment-reports": "adminRoutes.labels.reports",
  "/admin/webhook-logs": "adminRoutes.labels.webhookLogs",
  "/admin/merchants": "adminRoutes.labels.merchants",
  "/admin/test-merchant": "adminRoutes.labels.testMerchant",
  "/admin/payment-gateway-settings": "adminRoutes.labels.gatewaySettings",
  "/admin/promotions": "adminRoutes.labels.promotionsMenu",
  "/admin/lucky-wheel": "adminRoutes.labels.luckyWheel",
  "/admin/banners": "adminRoutes.labels.banners",
  "/admin/vip-levels": "adminRoutes.labels.vipLevels",
  "/admin/referral-system": "adminRoutes.labels.referralSystem",
  "/admin/reports": "adminRoutes.labels.reports",
  "/admin/advanced-reporting": "adminRoutes.labels.advancedReporting",
  "/admin/notifications": "adminRoutes.labels.notifications",
  "/admin/backup-management": "adminRoutes.labels.backup",
  "/admin/logs": "adminRoutes.labels.systemLogs",
  "/admin/receipts": "adminRoutes.labels.receipts",
  "/admin/support": "adminRoutes.labels.support",
  "/admin/whatsapp": "WhatsApp",
  "/admin/company-settings": "adminRoutes.labels.companySettings",
  "/admin/custom-messages": "adminRoutes.labels.customMessages",
  "/admin/auth-performance": "adminRoutes.labels.loginStats",
  "/admin/card-management": "adminRoutes.labels.cardManagement",
  "/admin/account-inventory": "adminRoutes.labels.accountInventory",
  "/admin/panel": "adminRoutes.labels.adminPanel",
  "/admin/settings": "adminRoutes.labels.generalSettings",
  "/admin/landing-page-settings": "adminRoutes.labels.landingPageSettings",
  "/admin/kyc-review": "adminRoutes.labels.kycReview",
};

const PATH_TO_DESC_KEY: Record<string, string> = {
  "/admin/dashboard": "adminRoutes.descs.mainDashboard",
  "/admin/system-monitoring": "adminRoutes.descs.systemMonitoring",
  "/admin/alert-analytics": "adminRoutes.descs.alertAnalytics",
  "/admin/risk-report": "adminRoutes.descs.riskReport",
  "/admin/fraud-detection": "adminRoutes.descs.fraudDetection",
  "/admin/security-center": "adminRoutes.descs.securityCenter",
  "/admin/users-management": "adminRoutes.descs.manageUsers",
  "/admin/users-credit": "adminRoutes.descs.userCredits",
  "/admin/admin-management": "adminRoutes.descs.manageAdmins",
  "/admin/transaction-management": "adminRoutes.descs.manageTransactions",
  "/admin/deposits": "adminRoutes.descs.deposit",
  "/admin/withdraws": "adminRoutes.descs.withdraw",
  "/admin/reconciliation": "adminRoutes.descs.reconciliation",
  "/admin/fee-management": "adminRoutes.descs.fees",
  "/admin/transaction-limits": "adminRoutes.descs.transactionLimits",
  "/admin/interest-settings": "adminRoutes.descs.interestSettings",
  "/admin/interest-payments": "adminRoutes.descs.interestPayments",
  "/admin/fixed-deposits": "adminRoutes.descs.fixedDeposits",
  "/admin/banks": "adminRoutes.descs.banks",
  "/admin/system-banks": "adminRoutes.descs.systemBanks",
  "/admin/currencies": "adminRoutes.descs.currencies",
  "/admin/exchange-rates": "adminRoutes.descs.exchangeRates",
  "/admin/auto-exchange-rates": "adminRoutes.descs.autoExchangeRates",
  "/admin/payment-gateway-dashboard": "adminRoutes.descs.paymentDashboard",
  "/admin/payment-gateways": "adminRoutes.descs.gateways",
  "/admin/payment-sessions": "adminRoutes.descs.paymentSessions",
  "/admin/merchant-payment-reports": "adminRoutes.descs.merchantPaymentReports",
  "/admin/webhook-logs": "adminRoutes.descs.webhookLogs",
  "/admin/merchants": "adminRoutes.descs.merchants",
  "/admin/test-merchant": "adminRoutes.descs.testMerchant",
  "/admin/payment-gateway-settings": "adminRoutes.descs.gatewaySettings",
  "/admin/promotions": "adminRoutes.descs.promotions",
  "/admin/lucky-wheel": "adminRoutes.descs.luckyWheel",
  "/admin/banners": "adminRoutes.descs.banners",
  "/admin/vip-levels": "adminRoutes.descs.vipLevels",
  "/admin/referral-system": "adminRoutes.descs.referralSystem",
  "/admin/reports": "adminRoutes.descs.reports",
  "/admin/advanced-reporting": "adminRoutes.descs.advancedReporting",
  "/admin/notifications": "adminRoutes.descs.notifications",
  "/admin/backup-management": "adminRoutes.descs.backup",
  "/admin/logs": "adminRoutes.descs.systemLogs",
  "/admin/receipts": "adminRoutes.descs.receipts",
  "/admin/support": "adminRoutes.descs.support",
  "/admin/whatsapp": "adminRoutes.descs.whatsapp",
  "/admin/company-settings": "adminRoutes.descs.companySettings",
  "/admin/custom-messages": "adminRoutes.descs.customMessages",
  "/admin/auth-performance": "adminRoutes.descs.loginStats",
  "/admin/card-management": "adminRoutes.descs.cardManagement",
  "/admin/account-inventory": "adminRoutes.descs.accountInventory",
  "/admin/panel": "adminRoutes.descs.adminPanel",
  "/admin/settings": "adminRoutes.descs.generalSettings",
  "/admin/landing-page-settings": "adminRoutes.descs.landingPageSettings",
  "/admin/kyc-review": "adminRoutes.descs.kycReview",
};

const GROUP_KEY_MAP: Record<string, string> = {
  "ภาพรวม": "adminRoutes.groups.overview",
  "จัดการผู้ใช้": "adminRoutes.groups.userManagement",
  "การเงิน": "adminRoutes.groups.finance",
  "ดอกเบี้ย": "adminRoutes.groups.interest",
  "ธนาคาร & สกุลเงิน": "adminRoutes.groups.banksCurrency",
  "Payment Gateway": "adminRoutes.groups.paymentGateway",
  "โปรโมชั่น": "adminRoutes.groups.promotions",
  "รายงานและระบบ": "adminRoutes.groups.reportsSystem",
  "การตั้งค่า": "adminRoutes.groups.settings",
};

// จัดกลุ่มเมนูตาม group (ภาษาเดิม)
export function getAdminMenuGroups(): AdminMenuGroup[] {
  const groupMap = new Map<string, AdminRouteConfig[]>();
  
  ADMIN_ROUTES.forEach(route => {
    if (!groupMap.has(route.group)) {
      groupMap.set(route.group, []);
    }
    groupMap.get(route.group)!.push(route);
  });

  return Array.from(groupMap.entries()).map(([title, items]) => ({
    title,
    items
  }));
}

// จัดกลุ่มเมนูพร้อมแปลภาษา
export function getLocalizedAdminMenuGroups(t: (key: string) => string): AdminMenuGroup[] {
  const groupMap = new Map<string, AdminRouteConfig[]>();
  
  ADMIN_ROUTES.forEach(route => {
    const groupKey = GROUP_KEY_MAP[route.group] || route.group;
    const groupLabel = t(groupKey);
    
    if (!groupMap.has(groupLabel)) {
      groupMap.set(groupLabel, []);
    }
    
    groupMap.get(groupLabel)!.push({
      ...route,
      label: t(PATH_TO_LABEL_KEY[route.path] || route.label),
      desc: t(PATH_TO_DESC_KEY[route.path] || route.desc),
    });
  });

  return Array.from(groupMap.entries()).map(([title, items]) => ({
    title,
    items
  }));
}

// หา route ตาม path
export function getRouteByPath(path: string): AdminRouteConfig | undefined {
  return ADMIN_ROUTES.find(r => r.path === path);
}

// เช็คว่า path นี้ต้อง redirect หรือไม่
export function getRedirectPath(path: string): string | null {
  const redirect = ADMIN_REDIRECTS.find(r => r.from === path);
  return redirect ? redirect.to : null;
}

// ============================================
// DEV-CHECK: Validate routes config
// ============================================
if (import.meta.env.DEV) {
  const invalidRoutes = ADMIN_ROUTES.filter(r => !r.label || !r.group || !r.path);
  if (invalidRoutes.length > 0) {
    console.warn("⚠️ Invalid admin routes detected (missing label/group/path):", invalidRoutes.map(r => r.path));
  }
  
  // Check for duplicate paths
  const paths = ADMIN_ROUTES.map(r => r.path);
  const duplicates = paths.filter((p, i) => paths.indexOf(p) !== i);
  if (duplicates.length > 0) {
    console.warn("⚠️ Duplicate admin route paths:", duplicates);
  }
  
  // Check redirect targets exist
  const validPaths = new Set(paths);
  const invalidRedirects = ADMIN_REDIRECTS.filter(r => !validPaths.has(r.to));
  if (invalidRedirects.length > 0) {
    console.warn("⚠️ Redirects pointing to non-existent routes:", invalidRedirects);
  }
}
